import React, { useEffect, useState } from 'react';
import CustomTabPanel from './customTabPanel';
import { Smtp } from './smtp/smtpList';
import Logger from './logger/loggerList';

export const ServerProductList = () => {
  const [selectedPanelStatus, setSelectedPanelStatus] = useState('SMTP');
  const [load, setLoad] = useState(true);

  return (
    <>
      <CustomTabPanel setSelectedPanelStatus={setSelectedPanelStatus} setLoad={setLoad} />

      {selectedPanelStatus === 'SMTP' && <Smtp load={load} setLoad={setLoad} />}
      {selectedPanelStatus === 'Logger' && <Logger load={load} setLoad={setLoad} />}
    </>
  );
};
